import { useBreadcrumb } from "hooks/useBreadcrumb";
import { useTranslation } from "react-i18next";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import config from "config/config";

import ServicesTopFAQ from "components/ServicesAndClaims/Services/ServicesTopFAQ";
import ServicesQuickLinks from "components/ServicesAndClaims/Services/ServicesQuickLinks";
import { getTasks } from "service/policy/getTasks";
import { getProductLineByPolicyType } from "js/utilities";
import {
  getServiceRequestDate,
  odsClaimStatusConversion,
  convertToTitleCase,
} from "js/formatting";
import EverlakeLoadingOverlay from "components/General/EverlakeLoadingOverlay";
import { ServiceRequest } from "./ServiceRequest";
import { isFlagEnabled } from "js/utilities";
import UploadDocumentsModal from "components/ModalDialogs/UploadDocuments/UploadDocumentsModal";

export const Services = ({ setOpenChatWindow }) => {
  const { t } = useTranslation();
  useBreadcrumb([
    { name: t("CustomerServiceRequest-home"), url: "/policies" },
    { name: t("CustomerServiceRequest-services"), url: "#" },
  ]);
  const { policies } = useSelector((state) => state.data);
  const { user } = useSelector((s) => s.user);
  const [services, setServices] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [modalState, setModalState] = useState(false);

  const getOldPolicy = (contractID) => {
    let policy = policies?.find((p) => p.contractID === contractID);
    if (policy) return policy.oldPolicy;
    return "";
  };
  const getProductType = (contractID) => {
    let policy = policies?.find((p) => p.contractID === contractID);
    if (policy) return policy?.product?.type;
    return "";
  };

  useEffect(() => {
    setIsLoading(true);
    let policyIds = policies.map((p) => p.contractID);
    getTasks({
      contractId_array: policyIds,
      agentId: "",
    })
      .then((response) => {
        const restrictedProcessServices =
          config.RESTRICTED_PROCESS_SERVICE_REQUEST.split(",");
        let serviceList = [];
        //sort newest to oldest
        response?.sort(function (a, b) {
          const firstDate = getServiceRequestDate(a);
          const secondDate = getServiceRequestDate(b);
          if (new Date(firstDate) > new Date(secondDate)) {
            return -1;
          }
          if (new Date(firstDate) < new Date(secondDate)) {
            return 1;
          }
          return 0;
        });
        response.forEach((task) => {
          if (
            !restrictedProcessServices.includes(task.process.toLowerCase()) &&
            task?.status?.toLowerCase() !== "e"
          ) {
            const [statusClass, statusText] = odsClaimStatusConversion(
              task.status,
              "serviceRequest"
            );

            serviceList.push({
              desc: convertToTitleCase(task.desc),
              oldPolicy: getOldPolicy(task.policyID.substring(2)),
              productType: getProductLineByPolicyType(
                getProductType(task.policyID.substring(2))
              ),
              statusClass: statusClass,
              statusText: statusText,
              contractID: task.policyID.substring(2),
              taskID: task.taskID,
              receivedDate: getServiceRequestDate(task),
            });
          }
        });

        if (serviceList?.length > 0) setServices(serviceList);
        setIsLoading(false);
      })
      .catch((error) => {
        console.error(
          "Server was unable to connect, please try again later.",
          error
        );
        setIsLoading(false);
      });
  }, [policies, user]);

  return (
    <>
      <EverlakeLoadingOverlay
        isLoading={isLoading}
        loadingText="Please wait while we retrieve services request..."
      >
        <div className="container ui-component-spacing">
          <h1>{t("CustomerServices-title")}</h1>
          <p>
            {t("CustomerServices-subtitle")}
            {isFlagEnabled("ENABLE_UPLOAD_DOCUMENTS") && (
              <div className="flex justify-end mb-4">
                <button
                  className="ui-btn-primary ui-btn-min-w ml-2"
                  onClick={() => {
                    setModalState(true);
                  }}
                >
                  Submit a Request
                </button>
              </div>
            )}
          </p>
          <hr />
        </div>

        <div className="container ui-component-spacing grid md:grid-cols-3 gap-12">
          <div className="md:col-span-2">
            <ServicesTopFAQ />
          </div>
          <div className="md:col-span-1">
            <ServicesQuickLinks />
          </div>
        </div>
        <div className="container ui-component-spacing">
          {isFlagEnabled("ENABLE_SHOWING_SERVICE_TRACKER_OVERVIEW") &&
            services.length > 0 && (
              <>
                <h2>{t("CustomerServices-title2")}</h2>
                <ServiceRequest
                  data={services}
                  setOpenChatWindow={setOpenChatWindow}
                />
              </>
            )}
        </div>
      </EverlakeLoadingOverlay>
      <UploadDocumentsModal
        modalState={modalState}
        setModalState={setModalState}
      />
    </>
  );
};
